import { useMemo } from 'react';
import _ from 'lodash';
import useRaffleTickets from './useRaffleTickets';

const useRaffleParticipants = (raffleKey) => {
  const { tickets, ready } = useRaffleTickets(raffleKey);

  const participants = useMemo(
    () =>
      _(tickets)
        .groupBy('from')
        .mapValues((tickets) => _.sumBy(tickets, 'ticketCount'))
        .value(),
    [tickets]
  );

  const result = useMemo(
    () => ({ participants, ready }),
    [participants, ready]
  );

  return result;
};

export default useRaffleParticipants;
